import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import crypto from 'crypto';
import { Authorization, ReleaseForms } from '@/constants/general';

interface Company {
    companyId: string | null;
    companyName: string | null;
    companyLogo: string | null;
    groupId: string | null;
    isSuperAdmin: boolean | null;
    isAdmin: boolean | null;
    testUser: boolean | null;
    bookstoreRazorPayMode: boolean | null;
    auth: Authorization[] | null;
    forms: ReleaseForms[] | null;
}

interface SessionType {
    company: string | undefined;
    setSession: (session: any) => void;
    getSession: () => Company | undefined;
    clearSession: () => void;
}

const SECRET_KEY = process.env.NEXT_PUBLIC_LOCAL_STORAGE_KEY;

// Ensure the secret key is 32 bytes long (required for AES-256)
const key = crypto.createHash('sha256').update(SECRET_KEY!).digest('base64').substr(0, 32);

// Generate a random initialization vector (IV)
const generateIV = () => crypto.randomBytes(16);

const encrypt = (data: any) => {
    const iv = generateIV();
    const cipher = crypto.createCipheriv('aes-256-cbc', Buffer.from(key), iv);
    let encrypted = cipher.update(JSON.stringify(data), 'utf8', 'hex');
    encrypted += cipher.final('hex');
    // Prepend the IV to the encrypted data (needed for decryption)
    return `${iv.toString('hex')}:${encrypted}`;
};

const decrypt = (data: any) => {
    const [ivHex, encryptedData] = data.split(':');
    const iv = Buffer.from(ivHex, 'hex');
    const decipher = crypto.createDecipheriv('aes-256-cbc', Buffer.from(key), iv);
    let decrypted = decipher.update(encryptedData, 'hex', 'utf8');
    decrypted += decipher.final('utf8');
    return JSON.parse(decrypted);
};

export const useAppStore = create<SessionType>()(
    persist(
        (set, get) => ({
            company: undefined,
            setSession: (company: Company) => {
                // console.log(company);
                const encryptedCompany = encrypt(company);
                set({ company: encryptedCompany });
            },
            getSession: () => {
                const state = get();
                if (!state.company) {
                    return undefined;
                }
                const decryptedCompany = decrypt(state.company);
                return decryptedCompany;
            },
            clearSession: () => {
                // set(() => initialState);
                sessionStorage.removeItem('secure-storage');
                // sessionStorage.clear(); // or localStorage.clear();
            },
        }),
        {
            name: 'secure-storage',
            storage: createJSONStorage(() => sessionStorage),
        },
    ),
);
